<img [src]="customerLogoUrl" height="50px" class="float-right userLogo" *ngIf="showLogo" />

<dx-popup class="popup" [showTitle]="true" [title]="'KLANTLOGO.POPUP.TITEL' | translate" [dragEnabled]="false"
    [hideOnOutsideClick]="true" [(visible)]="popupVisible" [showCloseButton]="true">

    <div *dxTemplate="let data of 'content'">
        <div class="alert alert-danger" role="alert" *ngIf="!showLogo">
            <ul>
                <li>{{ 'KLANTLOGO.POPUP.GEEN_LOGO' | translate }}</li>
            </ul>
        </div>

        <div class="row">
            <div class="col-md-10" *ngIf="showLogo">
                <img [src]="customerLogoUrl" class="img img-fluid" />
            </div>
            <div class="col-md-2" *ngIf="allowCreate">
                <dx-file-uploader #fileUploader [multiple]="false" accept="image/*" [(value)]="value"
                    uploadMode="instantly" [uploadUrl]="uploadUrl"
                    [selectButtonText]="'KLANTLOGO.POPUP.BUTTON_UPLOAD' | translate" labelText="" showFileList="false"
                    [uploadedMessage]="'ALGEMEEN.GELUKT' | translate"
                    [uploadedFailedMessage]="'ALGEMEEN.MISLUKT' | translate" (onUploaded)="fileUploaded($event)"
                    [uploadHeaders]="uploadHeader" *ngIf="allowCreate"></dx-file-uploader>
            </div>
        </div>
    </div>
</dx-popup>